import { z } from 'zod';
import { SourceRefSchema, about, sourceOf } from '../schema_fields.ts';

// The video tile: a camera's stream; a tap shows it full screen (tiles spec TB-1). Two ways
// (video-hls.md VH-2): the stream's address typed in, as every tile before; or a source that gives
// a live stream (an HLS playlist, such as a Home Assistant camera's).

/** The first way. Strict, so that a tile with a source is the other. */
export const VideoByUrlSchema = z.strictObject({
    /** RTSP (or another stream URL); the path or the user part often holds a key. */
    url: z.string().regex(/^[a-z][a-z0-9+.-]*:\/\//i, 'a URL').meta({ ...about('Stream', 'the camera\'s RTSP or other stream URL'), secret: true }),
})
.meta(about('An address', 'the camera\'s RTSP address, typed in'));

/** The other way: a source that gives the stream (VH-1). */
export const VideoBySourceSchema = z.strictObject({
    source: sourceOf(SourceRefSchema, { gives: ['video'], label: 'Camera' }),
})
.meta(about('From a source', 'a camera\'s live video from a connection, such as Home Assistant'));

export const VideoOptionsSchema = z.union([VideoByUrlSchema, VideoBySourceSchema]);
